export default __webpack_public_path__ + "static/media/Task-U.c5108a40.png";